import { GravyBinder } from 'gravy-bind';
import { touchAllInputs } from "../utils/touch-all-inputs";
import { IErrorValidator } from "./../utils/error-validator.interface";
import reportValidity from 'report-validity';
import { formHasValue } from "../utils/form-has-value";

export class ForgotPassword implements IErrorValidator {
    public static id = 'forgotpassword';
    public rootElement: HTMLFormElement;
    public recaptcha: string;
    private submitAttempted = false;
    private binder: GravyBinder;
    private submitButton: HTMLElement;

    constructor(element: HTMLElement) {
        this.rootElement = element as HTMLFormElement;
        this.submitButton = document.getElementById('submitButton');
        this.initialize()
    }

    initialize() {
        this.binder = new GravyBinder(this, this.rootElement);
        this.binder.updateBindings();
        this.rootElement.addEventListener('submit', this.onSubmit);
    }

    public highlightError = (formInputName: string): boolean => {
        if (!this.submitAttempted)
            return false;
        return formHasValue(this.rootElement, formInputName);
    }

    private onSubmit = (event: Event): void => {
        event.preventDefault();
        this.submitAttempted = true;
        this.binder.updateOutwardBindings();
        touchAllInputs(this.rootElement);
        reportValidity(this.rootElement);

        if (this.rootElement.checkValidity())
            this.rootElement.submit();
    }
}